import React from 'react';
import { ContactUsLink } from './ContactUsLink';

type SearchFormContactUsLinkProps = { className?: string; href: string };

export const ContactUsMessage: React.FC<SearchFormContactUsLinkProps> = ({ className, href }) => (
    <p>
        For assistance, please{' '}
        <ContactUsLink className={className} href={href}>
            contact us
        </ContactUsLink>{' '}
        to assist you with booking.
    </p>
);
